import React, { FC, PropsWithChildren, ReactNode } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import { graphql } from 'relay-runtime';
import { T } from 'src/shared/helpers';
import usePermissions from 'src/shared/hooks/usePermissions';
import LockIcon from 'src/shared/icons/lock-solid.svg';
import styled from 'styled-components';
import { Section } from '../section';
import { ifCanAccessQuery } from './__generated__/ifCanAccessQuery.graphql';
import { Icon } from '../icon';
import { LinkButton } from '../buttons';
import { ContainerBase } from '../layouts';

const StyledContainerBase = styled(ContainerBase)`
    padding: 0;
`;

const StyledIcon = styled(Icon)`
    width: 96px;
    height: 96px;
`;

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const IfCanAccess: FC<PropsWithChildren<{ permission: string; fallback?: ReactNode }>> = ({ permission, fallback, children }) => {
    const { user } = useLazyLoadQuery<ifCanAccessQuery>(
        graphql`
            query ifCanAccessQuery {
                user {
                    email
                }
            }
        `,
        {}
    );

    const { isAllowed } = usePermissions();
    if (!isAllowed([permission])) {
        return (
            fallback || (
                <StyledContainerBase>
                    <Section>
                        <StyledContainer>
                            <StyledIcon>
                                <LockIcon />
                            </StyledIcon>

                            <h3>{T._("You don't have the permissions to access this page", 'Admin')}</h3>
                            <p>{T._('Email the account owner to get access to this page.', 'Admin')}</p>
                            <LinkButton href={'mailto:' + user.email}>{T._('Request access', 'Admin')}</LinkButton>
                        </StyledContainer>
                    </Section>
                </StyledContainerBase>
            )
        );
    }

    return <>{children}</>;
};

export default IfCanAccess;
